import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';

export default function Navbar(){
  const [open, setOpen] = useState(false);
  return (
    <>
      {/* menu button */}
      <div className="fixed top-4 left-4 z-50">
        <button aria-label="menu" onClick={()=>setOpen(true)} className="p-2 rounded-full bg-black/60 hover:bg-black/80 text-white shadow">
          <FiMenu size={20} />
        </button>
      </div>

      {/* overlay */}
      <div className={`${open ? 'fixed' : 'hidden'} inset-0 bg-black/40 z-40`} onClick={()=>setOpen(false)} />

      {/* sidebar */}
      <aside className={`fixed top-0 left-0 h-full w-72 bg-gradient-to-b from-black/80 to-black/70 text-white p-6 transform ${open ? 'translate-x-0' : '-translate-x-full'} transition-transform z-50`}>
        <div className="flex items-center justify-between mb-6">
          <Link to="/" onClick={()=>setOpen(false)} className="text-2xl font-extrabold">PESPATRON44RUS WW Z</Link>
          <button onClick={()=>setOpen(false)} className="p-2 rounded-full bg-black/30 hover:bg-black/50">
            <FiX size={18} />
          </button>
        </div>

        <nav className="flex flex-col gap-3">
          <Link to="/" onClick={()=>setOpen(false)} className="px-3 py-2 rounded hover:bg-white/5">Главная</Link>
          <Link to="/chat" onClick={()=>setOpen(false)} className="px-3 py-2 rounded hover:bg-white/5">Статистика чата</Link>
          <Link to="/kto" onClick={()=>setOpen(false)} className="px-3 py-2 rounded hover:bg-white/5">Кто чаще</Link>
          <Link to="/ktoskazal" onClick={()=>setOpen(false)} className="px-3 py-2 rounded hover:bg-white/5">Кто сказал</Link>
        </nav>

        <div className="mt-6 text-sm text-gray-400">ку пёс</div>
      </aside>
    </>
  );
}
